/* global $, preloader, Scrollbar: false, gsap */

function scrolledWindow() {

	'use strict';

	let body = $('body');

	let scroll = $( window ).scrollTop();

	if (scroll >= 150 || window.innerWidth < 992) {
		body.addClass('scrolled');
	} else {
		body.removeClass('scrolled');
	}

}

( function() {

	'use strict';

} )();

$( document ).ready(function() {
	'use strict';

	scrolledWindow();

	$('[data-toggle="room-tooltip"]').tooltip();

	$('[data-toggle="tooltip"]').tooltip();

	Scrollbar.initAll();

	$('.map-tooltip').tooltip({
	}).on('hidden.bs.tooltip', function () {
		$(this).removeClass('map-tooltip-active');
		$('.btn-tooltip[data-pin=' + $(this).data('pin') + ']').removeClass('btn-tooltip-active');
	}).on('shown.bs.tooltip', function () {
		$(this).addClass('map-tooltip-active');
		$('.btn-tooltip[data-pin=' + $(this).data('pin') + ']').addClass('btn-tooltip-active');
	});

	$('.hotel-map-modals .modal').on('shown.bs.modal', function (event) {
		$('#' + event.target.id + ' .slideshow').flickity('resize');
	});

	$('.btn-tooltip')
		.on( 'mouseover', function() {
			$(this).addClass('btn-tooltip-active');
			$('.map-tooltip[data-pin=' + $(this).data('pin') + ']').tooltip('show');
		}).on( 'mouseout', function() {
		$(this).removeClass('btn-tooltip-active');
		$('.map-tooltip[data-pin=' + $(this).data('pin') + ']').tooltip('hide');
	});

	/**
	 * Video Gallery Modals
	 */
	let $modals = $('.modal');
	if ($modals.length > 0) {
		$modals.each(function(){
			let src = $(this).find('iframe').attr('src');

			$(this).on('click', function(){

				$(this).find('iframe').attr('src', '');
				$(this).find('iframe').attr('src', src);

			});
		});
	}

	/**
	 * Masonry Gallery
	 */
	let $gallery = $('.masonry-gallery');
	if ($gallery.length > 0) {
		if ($gallery.data('isotope')) {
			/**
			 * Isotope after all images have loaded
			 */
			$gallery.imagesLoaded().progress(function() {
				$gallery.isotope('layout');
			});

			/**
			 * Filter items on button click
			 */
			$('.masonry-gallery-filters').on('click', 'li a', function() {
				if (typeof preloader === 'function') {
					$gallery.find('.gallery-item').preloader(
						{
							loader: '/app/themes/nelios-base/svg/loader/preloader.svg',
							fadeIn: 300,
							delay: 100
						}
					);
				}

				$gallery.isotope(
					{
						filter: $(this).attr('data-filter')
					}
				);
			});
		} else if ($gallery.data('masonry')) {
			$gallery.imagesLoaded().progress(function() {
				$gallery.isotope('layout');
			});
		}
	}

	/**
	 * Homepage Hotels Flickity Init.
	 */
	const $hotelsSlideshow = $('.home-hotels.slideshow');
	const $hotelExcerpts = $('.home-hotel-excerpt');
	if ($hotelsSlideshow) {
		$hotelsSlideshow.flickity({
			wrapAround: false,
			contain: true,
			autoPlay: false,
			prevNextButtons: true,
			pageDots: true,
			cellSelector: '.slideshow-cell',
			arrowShape: 'M25 50L75 0 46.43 50 75 100 25 50z',
		});

		function addPrevNext() {
			let $allSlides = $hotelsSlideshow.find('.slideshow-cell');
			let $currentSlide = $hotelsSlideshow.find('.is-selected');
			let count = $allSlides.length;
			let position = $currentSlide.index();
			if (position === 0) {
				$allSlides.last().addClass('previous');
				$allSlides.not($allSlides.last()).removeClass('previous');
			} else {
				$currentSlide.prev().addClass('previous');
				$allSlides.not($currentSlide.prev()).removeClass('previous');
			}
			if (position === count - 1) {
				$allSlides.first().addClass('next');
				$allSlides.not($allSlides.first()).removeClass('next');
			} else {
				$currentSlide.next().addClass('next');
				$allSlides.not($currentSlide.next()).removeClass('next');
			}
		}

		addPrevNext();

		$hotelsSlideshow.on(
			'change.flickity',
			function( event, index ) {
				let $activeExcerpt = $hotelExcerpts.children().eq(index);
				let $otherExcerpts = $hotelExcerpts.children().not($activeExcerpt);
				$activeExcerpt.addClass('d-block').removeClass('d-none');
				$otherExcerpts.addClass('d-none').removeClass('d-block');
				addPrevNext();
			}
		);
	}

	/**
	 * Accommodation Filtering
	 */
	let filters = $('.filters');
	if (filters.length > 0) {
		let listingWrapper = $('.listing-wrapper');
		listingWrapper.imagesLoaded(
			function () {
				listingWrapper.isotope(
					{
						itemSelector: 'article',
					}
				);
			}
		);

		filters.on('click', 'a', function() {
			let filterValue = $(this).attr('data-filter');
			listingWrapper.isotope(
				{
					filter: filterValue
				}
			);
		});
	}

	/**
	 * Isotope Accordion Slideshow with Filtering for Hotels and Restaurants Listing.
	 */
	const $AccordionSlideshow = $('.accordion-slideshow');
	const $AccordionFilters = $('.accordion-slideshow-filters');
	if ($AccordionSlideshow.length > 0) {
		$AccordionFilters.on('click', 'li a', function () {
			const filter = $(this).data('filter');
			$(this).addClass('active');
			$AccordionFilters.find('a').not($(this)).removeClass('active');
			let $activeElements = $AccordionSlideshow.children(filter);
			let $otherElements = $AccordionSlideshow.children().not($activeElements);
			if ('*' !== filter) {
				$activeElements.show();
				$otherElements.hide();
			} else {
				$AccordionSlideshow.children().show();
			}

			$activeElements.each(function(index){
				$(this).attr('data-group',parseInt(index / 3));
			});
			$otherElements.each(function(){
				$(this).attr('data-group',-1);
			});

			highlightsStretcher();
		});
	}

	/**
	 * Highlights Stretcher for hotel and restaurants listing
	 */

	function highlightsStretcher() {
		let highlightsStretcherItem = $('#accordion-slideshow-wrapper .accordion-slideshow-item:visible');
		if (highlightsStretcherItem.length > 0 ) {
			highlightsStretcherItem.each(function() {
				let $item = $(this);
				let groupName = $item.attr('data-group');
				$item.on({
					mouseenter: function() {
						$( this ).addClass('grow');
						$('#accordion-slideshow-wrapper [data-group="'+ $( this ).attr('data-group') +'"').not($(this)).filter(function() {
							return $(this).attr('data-group') === groupName;
						}).addClass('shrink');
					},
					mouseleave: function() {
						$( this ).removeClass('grow');
						$('#accordion-slideshow-wrapper [data-group="'+ $( this ).attr('data-group') +'"').not($(this)).filter(function() {
							return $(this).attr('data-group') === groupName;
						}).removeClass('shrink');
					}
				});
			});
		}
	}

	function timeline() {
		let $timeline = $('.timeline');
		if ($timeline) {
			let $event_buttons = $timeline.find('.timeline-event');
			let $slider = $timeline.find('.timeline-slides');
			let $dates = $timeline.find('.timeline-dates');
			let $date_buttons = $dates.find('.timeline-year');

			$dates.flickity('reposition');

			// eslint-disable-next-line no-inner-declarations
			function selectEvent($eventButton) {
				let target_index = $eventButton.data('target');
				$eventButton.addClass('is-active');
				$event_buttons.not($eventButton).removeClass('is-active');
				$slider.flickity('select', target_index );
			}

			$event_buttons.on('click', function() {
				selectEvent($(this));
			});

			function selectDate($dateButton) {
				let target_index = $dateButton.data('target');
				$dateButton.addClass('is-active');
				$date_buttons.not($dateButton).removeClass('is-active');
				$dates.flickity('select', target_index );
				let $date_slide = $dateButton.parent().parent();
				let $first_event = $date_slide.find('.timeline-event').first();
				selectEvent($first_event);
			}

			$date_buttons.on('click', function() {
				selectDate($(this));
			});

			$dates.on('change.flickity', function( event, index ) {
				$dates.flickity('reposition');
				let $dateButton = $date_buttons.eq(index);
				$dateButton.addClass('is-active');
				$date_buttons.not($dateButton).removeClass('is-active');
				let $date_slide = $dateButton.parent().parent();
				let $first_event = $date_slide.find('.timeline-event').first();
				selectEvent($first_event);
			});
		}
	}

	highlightsStretcher();
	timeline();
});

// $( window ).on('scroll', function() {
//
// });

$( window ).on('resize orientationchange scroll', function() {
	scrolledWindow();
});

$( window ).on('resize orientationchange', function() {
	let readMoreToggle = $('.read-more-toggle');
	if (readMoreToggle.length > 0) {
		readMoreToggle.each(function() {
			$( this ).readMoreToggler();
		});
	}
}).trigger('resize');

$(document).ready(function(){

	$('.zone-video-type-file').each(function() {
		var $playerWrapper = $(this);
		var $player = $playerWrapper.find('.video-player');
		var $play = $playerWrapper.find('.play-bt');
		var $pause = $playerWrapper.find('.pause-bt');
		var $stop = $playerWrapper.find('.stop-bt');
		var $mute = $playerWrapper.find('.mute-bt');
		var $muteIcon = $mute.find('.mute');
		var $unmuteIcon = $mute.find('.unmute');

		$muteIcon.hide();
		$player.prop('currentTime', 0);

		if (document.querySelector('.home .first-slideshow .home-video')) {
			if (document.querySelector('.home .first-slideshow .home-video').classList.contains('isMobile')) {
				$pause.hide();
			} else {
				$play.hide();
			}
		} else if ( document.querySelector('.tax-event_category .first-slideshow') ) {
			$play.hide();
		}

		$mute.on('click', function() {
			if ($(this).hasClass('stop')) {
				$player.prop('muted', true);
				$(this).removeClass('stop');
				$muteIcon.hide();
				$unmuteIcon.show();
			} else {
				$player.prop('muted', false);
				$(this).addClass('stop');
				$muteIcon.show();
				$unmuteIcon.hide();
			}
		});

		$play.on('click', function() {
			$(this).hide();
			$pause.show();
			if ($stop.hasClass('active')) {
				$player.prop('currentTime', 0);
			}
			$stop.removeClass('active').show();
			$player.trigger('play');
		});

		$pause.on('click', function() {
			$(this).addClass('active').hide();
			$play.show();
			$stop.removeClass('active');
			$player.trigger('pause');
		});

		$stop.on('click', function() {
			$play.show();
			$pause.removeClass('active').hide();
			$(this).addClass('active').hide();
			$player.trigger('pause');
		});
	});

	if ($("body").hasClass("page-template-experiences")) {
		let checkboxes = $('.service-checkbox');

		$(".service-checkbox").change(function(){
			let checkboxes = $('.service-checkbox');
			let anyChecked=false;
			for (let i=0; i<checkboxes.length; i++) {
				if (checkboxes[i].checked){
					anyChecked=true;
					break;
				}
			}
			if (!anyChecked) {
				$( "#concierge_book_now" ).prop('disabled', true);
			}
			else {
				$( "#concierge_book_now" ).removeAttr("disabled");
			}
		})

		$( "#concierge_deselect_all" ).click(function() {
			for (let i=0; i<checkboxes.length; i++) {
				checkboxes[i].checked = false;
			}
			$( "#concierge_book_now" ).prop('disabled', true);
		});
		$( "#concierge_book_now" ).click(function() {
			let selectedServicesWrapper = document.querySelector('.selected-services-wrapper');
			selectedServicesWrapper.innerHTML = '';
			for (let i=0; i<checkboxes.length; i++) {
				if (checkboxes[i].checked) {
					let tmpItem = '<div>' + checkboxes[i].parentElement.parentElement.parentElement.children[1].innerHTML + '</div>';
					selectedServicesWrapper.innerHTML += tmpItem;
				}
			}

			let services = document.querySelector('#contact-form #services')
			let hotel = document.querySelector('#contact-form #hotel_name');
			let hotel_id = document.querySelector('#contact-form #hotel_id');

			let selectedServices = $('.modal-body .service');

			for (let i=0; i<selectedServices.length; i++) {
				services.value += "Service: " + selectedServices[i].querySelector('.service-name').innerHTML;
			}

			hotel_id.value = $('#hotel_select').val();
			hotel.value =  $('#hotel_select option:selected').text();
		});

		$( '.wpcf7-submit' ).on( "click",function(e) {
			let customError = $('#contact-form .custom_cf_error');
			let firstName = $( '#contact-form #firstname' );
			let lastName = $( '#contact-form #lastname' );
			let email = $( '#contact-form #email' );
			let phone = $( '#contact-form #phone' );
			let roomNumber = $( '#contact-form #room_number' );
			let reservationID = $( '#contact-form #reservation_id' );

			if (email.val() == '' && phone.val() == ''){
				customError.html('Please fill email or phone');
				e.preventDefault();
			}
			if (roomNumber.val() == '' && reservationID.val() == ''){
				customError.html('Please fill room number or reservation id');
				e.preventDefault();
			}
			if (firstName.val() == '' || lastName.val() == '' ){
				customError.html('Please fill in the required fields');
				e.preventDefault();
			}
			if ( (!email.val().includes('@') || !email.val().includes('.') ) && email.val() != '')  {
				customError.html('One or more fields have an error. Please check and try again.');
				e.preventDefault();
			}
		});

		if ($('.wpcf7-response-output') != null && $('.wpcf7-response-output').html() != "") {
			$('#concierge-modal').modal('show');
		}
	}

	const roomGallery = document.querySelector(".room-masonry-gallery.show-more");

	if ( roomGallery ) {
		const btnShowMore = document.querySelector(".btn-show-more");
		const btnShowLess = document.querySelector(".btn-show-less ");

		btnShowMore.addEventListener("click", (event) => {
			btnShowMore.classList.add("d-none");
			btnShowLess.classList.remove("d-none");
			roomGallery.classList.remove("show-more");
		});

		btnShowLess.addEventListener("click", (event) => {
			btnShowLess.classList.add("d-none");
			btnShowMore.classList.remove("d-none");
			roomGallery.classList.add("show-more");

		});
	}

});

if ( document.querySelector(".loyalty-levels") ) {
	let slideshow = document.querySelector(".loyalty-levels .slideshow");

	function removeClasses() {
		slideshow.classList.remove("row");
		Array.from(document.querySelectorAll('.loyalty-levels .slideshow-cell')).forEach(function(el) {
			el.classList.remove('col-12', 'col-md-6', 'col-lg-3');
		});
	}

	function addClasses() {
		slideshow.classList.add("row");
		Array.from(document.querySelectorAll('.loyalty-levels .slideshow-cell')).forEach(function(el) {
			el.classList.add('col-12', 'col-md-6', 'col-lg-3');
		});
	}

	if (window.innerWidth < 576) {
		removeClasses();
	}
	else {
		addClasses();
	}
	window.addEventListener('resize', function(event) {
		if (window.innerWidth < 576) {
			removeClasses();
		}
		else {
			addClasses();
		}
	}, true);
}

if ($("body").hasClass("page-template-contact")) {

	function MultiselectDropdown(options){
		var config={
			search:true,
			height:'15rem',
			placeholder:'select',
			txtSelected:'selected',
			txtAll:'All',
			txtRemove: 'Remove',
			txtSearch:'search',
			...options
		};
		function newEl(tag,attrs){
			var e=document.createElement(tag);
			if(attrs!==undefined) Object.keys(attrs).forEach(k=>{
				if(k==='class') { Array.isArray(attrs[k]) ? attrs[k].forEach(o=>o!==''?e.classList.add(o):0) : (attrs[k]!==''?e.classList.add(attrs[k]):0)}
				else if(k==='style'){
					Object.keys(attrs[k]).forEach(ks=>{
						e.style[ks]=attrs[k][ks];
					});
				}
				else if(k==='text'){attrs[k]===''?e.innerHTML='&nbsp;':e.innerText=attrs[k]}
				else e[k]=attrs[k];
			});
			return e;
		}


		document.querySelectorAll("select[multiple]").forEach((el,k)=>{

			var div=newEl('div',{class:'multiselect-dropdown',style:{width:config.style?.width??el.clientWidth+'px',padding:config.style?.padding??''}});
			el.style.display='none';
			el.parentNode.insertBefore(div,el.nextSibling);
			var listWrap=newEl('div',{class:'multiselect-dropdown-list-wrapper'});
			var list=newEl('div',{class:'multiselect-dropdown-list',style:{height:config.height}});
			var search=newEl('input',{class:['multiselect-dropdown-search'].concat([config.searchInput?.class??'form-control']),style:{width:'100%',display:el.attributes['multiselect-search']?.value==='true'?'block':'none'},placeholder:config.txtSearch});
			listWrap.appendChild(search);
			div.appendChild(listWrap);
			listWrap.appendChild(list);

			el.loadOptions=()=>{
				list.innerHTML='';

				if(el.attributes['multiselect-select-all']?.value=='true'){
					var op=newEl('div',{class:'multiselect-dropdown-all-selector'})
					var ic=newEl('input',{type:'checkbox'});
					op.appendChild(ic);
					op.appendChild(newEl('label',{text:config.txtAll}));

					op.addEventListener('click',()=>{
						op.classList.toggle('checked');
						op.querySelector("input").checked=!op.querySelector("input").checked;

						var ch=op.querySelector("input").checked;
						list.querySelectorAll(":scope > div:not(.multiselect-dropdown-all-selector)")
							.forEach(i=>{if(i.style.display!=='none'){i.querySelector("input").checked=ch; i.optEl.selected=ch}});

						el.dispatchEvent(new Event('change'));
					});
					ic.addEventListener('click',(ev)=>{
						ic.checked=!ic.checked;
					});
					el.addEventListener('change', (ev)=>{
						let itms=Array.from(list.querySelectorAll(":scope > div:not(.multiselect-dropdown-all-selector)")).filter(e=>e.style.display!=='none')
						let existsNotSelected=itms.find(i=>!i.querySelector("input").checked);
						if(ic.checked && existsNotSelected) ic.checked=false;
						else if(ic.checked==false && existsNotSelected===undefined) ic.checked=true;
					});

					list.appendChild(op);
				}

				Array.from(el.options).map(o=>{
					var op=newEl('div',{class:o.selected?'checked':'',optEl:o})
					var ic=newEl('input',{type:'checkbox',checked:o.selected});
					op.appendChild(ic);
					op.appendChild(newEl('label',{text:o.text}));

					op.addEventListener('click',()=>{
						op.classList.toggle('checked');
						op.querySelector("input").checked=!op.querySelector("input").checked;
						op.optEl.selected=!!!op.optEl.selected;
						el.dispatchEvent(new Event('change'));
					});
					ic.addEventListener('click',(ev)=>{
						ic.checked=!ic.checked;
					});
					o.listitemEl=op;
					list.appendChild(op);
				});
				div.listEl=listWrap;

				div.refresh=()=>{
					div.querySelectorAll('span.optext, span.placeholder').forEach(t=>div.removeChild(t));
					var sels=Array.from(el.selectedOptions);
					if(sels.length>(el.attributes['multiselect-max-items']?.value??5)){
						div.appendChild(newEl('span',{class:['optext','maxselected'],text:sels.length+' '+config.txtSelected}));
					}
					else{
						sels.map(x=>{
							var c=newEl('span',{class:'optext',text:x.text, srcOption: x});
							if((el.attributes['multiselect-hide-x']?.value !== 'true'))
								c.appendChild(newEl('span',{class:'optdel',innerHTML:'<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width: 1rem; height: 1rem;"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>',title:config.txtRemove, onclick:(ev)=>{c.srcOption.listitemEl.dispatchEvent(new Event('click'));div.refresh();ev.stopPropagation();}}));

							div.appendChild(c);
						});
					}
					if(0==el.selectedOptions.length) div.appendChild(newEl('span',{class:'placeholder',text:el.attributes['placeholder']?.value??config.placeholder}));
				};
				div.refresh();
			}
			el.loadOptions();

			search.addEventListener('input',()=>{
				list.querySelectorAll(":scope div:not(.multiselect-dropdown-all-selector)").forEach(d=>{
					var txt=d.querySelector("label").innerText.toUpperCase();
					d.style.display=txt.includes(search.value.toUpperCase())?'block':'none';
				});
			});

			div.addEventListener('click',()=>{
				div.listEl.style.display='block';
				search.focus();
				search.select();
			});

			document.addEventListener('click', function(event) {
				if (!div.contains(event.target)) {
					listWrap.style.display='none';
					div.refresh();
				}
			});
		});
	}

	// $(document).ready(function(){
	//
	// 	let form_submit = document.querySelector('#contact-form-1207 .wpcf7-submit');
	//
	// 	let form_reset = document.querySelector('#contact-form-1207 [type="reset"]');
	//
	// 	form_reset.addEventListener('click', function(e) {
	// 		let checkedItems = document.querySelectorAll('.multiselect-dropdown .optdel');
	// 		for (let i=0; i<checkedItems.length; i++) {
	// 			checkedItems[i].click();
	// 		}
	// 	});
	//
	// 	form_submit.addEventListener('click', function(e) {
	// 		let hotelslist = document.querySelector('#hotel_list_field');
	//
	// 		let checkedItems = document.querySelectorAll('.multiselect-dropdown-list .checked label');
	// 		document.querySelector('#hotel_list_field').value = "";
	// 		for (let i=0; i<checkedItems.length; i++) {
	// 			document.querySelector('#hotel_list_field').value += checkedItems[i].innerText;
	// 			if (i !== checkedItems.length-1)
	// 				document.querySelector('#hotel_list_field').value += ', ';
	// 		}
	//
	// 		if (hotelslist.value == '') {
	// 			e.preventDefault();
	// 			document.querySelector('.custom-hotel-list-error').classList.remove('d-none');
	// 		}
	// 		else {
	// 			document.querySelector('.custom-hotel-list-error').classList.add('d-none');
	// 		}
	// 	})
	//
	// });
	// window.addEventListener('load',()=>{
	// 	MultiselectDropdown(window.MultiselectDropdownOptions);
	// });
}

const getSiblings = (el) => Array.from(el.parentNode.children).filter((ch) => ch !== el);

const mainMenuButtonToggler = document.getElementById('navbar-toggler');
const megaMenuWrapper = document.getElementById('mega-menu-wrapper');

if (mainMenuButtonToggler && megaMenuWrapper) {
	const megaMenuContainer = megaMenuWrapper.querySelector('.mega-menu-container');
	const closeButtons = megaMenuWrapper.querySelectorAll('.close-button');
	const middleMenuWrapper = megaMenuWrapper.querySelector('.middle-menu-wrapper');
	const primaryMenu = megaMenuWrapper.querySelector('#primary-menu');
	const primaryMenuItems = primaryMenu.querySelectorAll('.menu-item.dropdown');
	const hotelsMenu = middleMenuWrapper && middleMenuWrapper.querySelector('#hotels-menu');
	const hotelsMenuItems = hotelsMenu && hotelsMenu.querySelectorAll('[data-hotel-page]');
	const rightMenuWrapper = megaMenuWrapper.querySelector('.right-menu-wrapper');
	const backButtons = megaMenuWrapper.querySelectorAll('.back-button-wrapper');
	// const allPrimaryMenuItems = primaryMenu.querySelectorAll('.menu-item');

	// if (document.body.classList.contains('home')) {
	// 	gsap.set(allPrimaryMenuItems, {
	// 		opacity: 0
	// 	});
	// }

	const clearPrimaryMenu = () => {
		if (!primaryMenu) return;
		Array.from(primaryMenu.querySelectorAll('.menu-item')).map(it => it.classList.remove('active'));
	}

	const clearMiddleMenuWrapper = () => {
		if (!middleMenuWrapper) return;
		middleMenuWrapper.classList.remove('active');
		Array.from(middleMenuWrapper.querySelectorAll('.list-menu')).map(it => it.classList.remove('active'));
		Array.from(middleMenuWrapper.querySelectorAll('.menu-item')).map(it => it.classList.remove('active'));
	}

	const clearRightMenuWrapper = () => {
		if (!rightMenuWrapper) return;
		rightMenuWrapper.classList.remove('active');
		Array.from(rightMenuWrapper.querySelectorAll('.hotel-menu-area')).map(it => it.classList.remove('active'));
	}

	Array.from(primaryMenuItems).map(item => {
		if (!document.body.classList.contains('page-template-hotel')) {
			let lnk = item.querySelector('a');
			lnk && lnk.addEventListener('click', (ev) => {
				ev.preventDefault();
				clearMiddleMenuWrapper();
				clearRightMenuWrapper();
				middleMenuWrapper.classList.add('active');
				getSiblings(item).map(it => it.classList.remove('active'));
				item.classList.add('active');

				// Find the n-th menu element to activate
				let middleMenuToActive = Array.from(middleMenuWrapper.querySelectorAll('.list-menu'))[Array.from(primaryMenuItems).indexOf(item)];
				getSiblings(middleMenuToActive).map(it => it.classList.remove('active'));
				middleMenuToActive.classList.add('active');

				if (window.innerWidth < 1200 && megaMenuContainer) {
					gsap.to(megaMenuContainer, {
						xPercent: -33.3333,
						ease: "power4.out",
						duration: .3
					});
				}
			});
		}
	});

	const closeMenuWrapper = () => {
		gsap.to(megaMenuWrapper, {
			y: '-104%',
			// ease: "power4.out",
			duration: .2,
			onComplete: () => {
				// if (document.body.classList.contains('home')) {
				// 	gsap.set(allPrimaryMenuItems, {
				// 		opacity: 0
				// 	});
				// }
				document.body.style.overflow = 'auto';
			},
		});
		// clearRightMenuWrapper();
		// clearMiddleMenuWrapper();
		// clearPrimaryMenu();
	}

	const openMenuWrapper = () => {
		// megaMenuWrapper.classList.add('active');
		document.body.style.overflow = 'hidden';
		gsap.to(megaMenuWrapper, {
			y: '0',
			// ease: "power4.out",
			duration: .3,
		});

		// if (document.body.classList.contains('home')) {
		// 	gsap.to(allPrimaryMenuItems, {
		// 		opacity: 1,
		// 		ease: "power4.out",
		// 		duration: 1,
		// 		stagger: .15
		// 	});
		// }
	}

	Array.from(closeButtons).map((btn) => btn.addEventListener('click', (event) => {
		event.preventDefault();
		closeMenuWrapper();
	}));

	hotelsMenuItems && Array.from(hotelsMenuItems).map((item) => {
		let lnk = item.querySelector('a');
		lnk && lnk.addEventListener('click', (ev) => {
			ev.preventDefault();
			getSiblings(item).map(it => it.classList.remove('active'));
			item.classList.add('active');
			rightMenuWrapper.classList.add('active');

			// Find the n-th menu element to activate
			let rightMenuToActivate = Array.from(rightMenuWrapper.querySelectorAll('.hotel-menu-area')).filter(menuArea => menuArea.dataset.hotelPage === item.dataset.hotelPage);
			getSiblings(rightMenuToActivate[0]).map(it => it.classList.remove('active'));
			rightMenuToActivate[0].classList.add('active');

			if (window.innerWidth < 1200 && megaMenuContainer) {
				gsap.to(megaMenuContainer, {
					xPercent: -66.7,
					ease: "power4.out",
					duration: .3
				});
			}
		})
	});

	const onMenuButtonTogglerClick = (event) => {
		event.preventDefault();
		openMenuWrapper();
	}

	mainMenuButtonToggler.addEventListener('click', onMenuButtonTogglerClick, false);

	Array.from(backButtons).map(button => {
		button.addEventListener('click', (event) => {
			event.preventDefault();
			let parentEl = button.closest('.middle-menu-wrapper') || button.closest('.right-menu-wrapper');
			// if (parentEl.classList.contains('.middle-menu-wrapper')) {
			gsap.to(megaMenuContainer, {
				xPercent: parentEl.classList.contains('middle-menu-wrapper') ? 0 : -33.3333,
				ease: "power4.out",
				duration: .3
			});
			// }
		});
	});

	document.addEventListener("keydown", (e) => {
		if ( e.keyCode === 27) closeMenuWrapper();
	});
}

document.addEventListener('DOMContentLoaded', function() {
	var container = document.querySelector('.container.single-post-content');
	if (container) {
		var h1Elements = container.querySelectorAll('h1');
		h1Elements.forEach(function(h1) {
			var h3 = document.createElement('h3');
			h3.innerHTML = h1.innerHTML;
			h1.parentNode.replaceChild(h3, h1);
		});
	}
});

